// frontend/src/components/AdicionarMarcoModal.jsx

import React, { useState, useEffect } from 'react';

const API_BASE_URL = 'https://sigoapi.jhe-etes.com.br/api';

function AdicionarMarcoModal({ isOpen, onClose, empreendimentoId, onSuccess }) {
  // Estado para os campos de texto
  const [formData, setFormData] = useState({
    titulo: '',
    descricao: '',
    data_marco: '',
    concluido: 0
  });

  // Estado para o arquivo
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  // Limpa tudo quando abre
  useEffect(() => {
    if (isOpen) {
      setFormData({ titulo: '', descricao: '', data_marco: '', concluido: 0 });
      setFile(null);
      setUploading(false);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    try {
      let finalImageUrl = '';

      // 1. SE TIVER ARQUIVO, FAZ UPLOAD PRIMEIRO
      if (file) {
        const uploadData = new FormData();
        uploadData.append('file', file);

        const uploadRes = await fetch(`${API_BASE_URL}/upload`, { 
            method: 'POST', 
            body: uploadData 
        });

        if (uploadRes.ok) {
            const result = await uploadRes.json();
            finalImageUrl = result.url; // Pega o caminho gerado (/uploads/...)
        } else {
            throw new Error("Falha no upload da imagem");
        }
      }

      // 2. DEPOIS SALVA O MARCO NO BANCO (Com a URL da imagem)
      const payload = {
        ...formData,
        empreendimento_id: empreendimentoId,
        concluido: parseInt(formData.concluido),
        imagem_url: finalImageUrl // Salva o caminho aqui
      };

      const response = await fetch(`${API_BASE_URL}/marcos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert("Novo marco adicionado com sucesso!");
        onSuccess();
        onClose();
      } else {
        alert("Erro ao adicionar marco.");
      }

    } catch (error) {
      console.error("Erro:", error);
      alert("Ocorreu um erro ao salvar.");
    } finally {
      setUploading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md border border-gray-200 m-4 max-h-[90vh] overflow-y-auto">
        
        <div className="flex justify-between items-center p-5 border-b border-gray-100 bg-gray-50 rounded-t-xl">
          <h2 className="text-lg font-bold text-sabesp-blue">Adicionar Novo Marco</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 font-bold">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
            
            {/* Título */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Título</label>
                <input type="text" name="titulo" required placeholder="Ex: Inauguração"
                    value={formData.titulo} onChange={handleChange} 
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-sabesp-cyan outline-none" />
            </div>

            {/* Descrição */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                <textarea name="descricao" rows="3" required placeholder="Detalhes sobre esta etapa..."
                    value={formData.descricao} onChange={handleChange} 
                    className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-sabesp-cyan outline-none resize-none" />
            </div>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data (Mês/Ano)</label>
                    <input type="text" name="data_marco" required placeholder="Jan 2025"
                        value={formData.data_marco} onChange={handleChange} 
                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-sabesp-cyan outline-none" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                    <select name="concluido" value={formData.concluido} onChange={handleChange} 
                        className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-sabesp-cyan outline-none">
                        <option value="0">Previsto (Roxo)</option>
                        <option value="1">Concluído (Verde)</option>
                    </select>
                </div>
            </div>

            {/* --- ÁREA DE UPLOAD (Igual ao Fluxograma) --- */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Foto do Marco (Opcional)</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:bg-gray-50 transition-colors relative">
                    <input 
                        type="file" 
                        accept="image/*" 
                        onChange={handleFileChange}
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    />
                    <div className="space-y-1">
                        <span className="text-2xl block">📷</span>
                        <span className="text-sm text-sabesp-cyan font-medium">Clique para selecionar foto</span>
                    </div>
                </div>
                {/* Feedback do arquivo */}
                {file && (
                    <div className="mt-2 text-xs flex items-center gap-2 text-green-600 bg-green-50 p-2 rounded border border-green-100">
                        <span>✅</span> Arquivo: <strong>{file.name}</strong>
                    </div>
                )}
            </div>
            {/* ------------------------------------------- */}

            <div className="pt-2 flex gap-3">
                <button type="button" onClick={onClose} className="flex-1 py-2 border border-gray-300 text-gray-600 rounded hover:bg-gray-50">Cancelar</button>
                <button 
                    type="submit" 
                    disabled={uploading}
                    className="flex-1 py-2 bg-sabesp-cyan text-white font-bold rounded hover:bg-cyan-600 disabled:opacity-50"
                >
                    {uploading ? 'Enviando...' : 'Adicionar'}
                </button>
            </div>
        </form>
      </div>
    </div>
  );
}

export default AdicionarMarcoModal;